module.exports = "/assets/037e49d8c58a7f90336993ffeb55b871.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TB.png
// module id = 1850
// module chunks = 0